/**
 * 인증 유틸리티 함수
 * 자체 JWT 인증 기반 - localStorage에서 토큰 조회
 */

/**
 * 현재 세션의 access token을 가져옴
 * 1. parent_access_token (학부모)
 * 2. student_access_token (학생)
 * 3. accessToken (레거시 폴백)
 */
export const getAccessToken = async (): Promise<string | null> => {
  return getAccessTokenSync();
};

/**
 * 동기적으로 access token을 가져옴 (localStorage)
 */
export const getAccessTokenSync = (): string | null => {
  // 역할별 토큰 확인
  const role = localStorage.getItem('unified_role');
  if (role === 'parent') {
    return localStorage.getItem('parent_access_token');
  }
  if (role === 'student') {
    return localStorage.getItem('student_access_token');
  }

  // 폴백: 순서대로 확인
  return localStorage.getItem('parent_access_token')
    || localStorage.getItem('student_access_token')
    || localStorage.getItem('accessToken');
};
